// Pure functions for difficulty curve. Read live tuning from `tuning` singleton
// so admin config changes take effect on next page load without code edits.

import { tuning } from './tuning.js';

export function dropSpeed(stageIdx) {
  return tuning.drop_base_pxs * (1 + tuning.drop_stage_mult * stageIdx);
}

export function spawnInterval(stageIdx) {
  // Linear interpolation between max (stage 0) and min (high stages).
  const step = (tuning.spawn_max_ms - tuning.spawn_min_ms) / 6;
  return Math.max(tuning.spawn_min_ms, tuning.spawn_max_ms - step * stageIdx);
}

export function maxParallel(stageIdx) {
  return Math.min(4, 1 + Math.floor(stageIdx / 1.5));
}

export function pickMugType({ fever, rng = Math.random }) {
  const goldenChance = fever ? tuning.golden_fever_chance : tuning.golden_chance;
  const bombChance = tuning.bomb_chance;
  const r = rng();
  if (r < bombChance) return 'bomb';
  if (r < bombChance + goldenChance) return 'golden';
  return 'normal';
}

export function scoreForCatch({ kind, combo, fever }) {
  const base = kind === 'golden' ? 50 : 10;
  const comboBonus = 1 + Math.min(combo, 30) / 10; // 1.0 → 4.0
  const feverMult = fever ? 3 : 1;
  return Math.round(base * comboBonus * feverMult);
}
